import { render, staticRenderFns } from "./ComfirmResultDialog.vue?vue&type=template&id=899fc0fc"
import script from "./ComfirmResultDialog.vue?vue&type=script&lang=js"
export * from "./ComfirmResultDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports